import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewPersonData,
  deletePeopleListData,
  fetchPeopleListData,
  updatePeopleListData,
} from "../thunks/peopleListThunks";

import type { People } from "../../utils/types/peopleList";

interface PeopleListState {
  peopleList: People[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}
const initialState: PeopleListState = {
  peopleList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const peopleListSlice = createSlice({
  name: "peopleList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPeopleListData.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
        state.error = null;
      })
      .addCase(fetchPeopleListData.fulfilled, (state, action) => {
        state.peopleList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchPeopleListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    builder
      .addCase(updatePeopleListData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePeopleListData.fulfilled, (state, action) => {
        state.loading = false;
        state.peopleList = state.peopleList.map((person) => {
          if (person.personId === action.payload?.personId) {
            return { ...person, ...action.payload };
          }
          return person;
        });
      })
      .addCase(updatePeopleListData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deletePeopleListData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePeopleListData.fulfilled, (state, action) => {
        state.loading = false;
        state.peopleList = state.peopleList.filter(
          (person) => person.personId !== action.payload?.id
        );
      })
      .addCase(deletePeopleListData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewPersonData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewPersonData.fulfilled, (state, action) => {
        state.loading = false;
        state.peopleList=[action.payload,...state.peopleList]
      })
      .addCase(addNewPersonData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
      addWebSocketCases(builder, "peopleList", "peopleList")
  },
});

export const { resetDataFetched } = peopleListSlice.actions;
export default peopleListSlice.reducer;
